export const toSourcedBase = (x: Models.V3.Base, source?: DataSource): Models.V3.SourcedBase => ({
    source: source || (x as Models.V3.SourcedBase).source,
    href: x.href,
    id: x.id,
});
